import React from "react";
import { useSlc, RootState } from "app/store";
import { profileLinks } from "app/constants";
import { SubNav } from "components/nav";
import { WrapperProfileWish } from "app/wrappers";
import RedirectTo from "components/RedirectTo/RedirectTo";

export const Wish = () => {
  const isAuth = useSlc((state: RootState) => state.user.isAuth);

  if (isAuth)
    return (
      <>
        <SubNav links={profileLinks} />
        <WrapperProfileWish />
      </>
    );
  return <RedirectTo path="/sign-in" />;
};
